<div
    class="gap-0 flex border shadow-none border-t border-b-0 border-x-0 p-0 rounded-none flex-col h-full overflow-hidden">
    <div class="h-14 bg-zinc-50 border-b p-2 px-4 space-y-2">
        <div class="flex flex-row items-center justify-between">
            <div class="flex items-center gap-2">
                <div
                    class="relative p-2 rounded-lg bg-gradient-to-br from-gray-300/20 to-gray-400/10 border border-gray-500/20 flex items-center justify-center">
                    <app-icon [type]="toolIcon().icon" [source]="toolIcon().iconSource ?? 'lucide'"
                        [class]="'w-5 h-5 text-gray-500'" [size]="'default'"></app-icon>
                </div>
                <h3 class="text-base font-medium text-zinc-900">
                    {{ toolTitle() }}
                </h3>
            </div>

            <div [ngClass]="{
            'px-2 py-1 rounded-md text-xs font-medium flex items-center': true,
            'bg-emerald-100 text-emerald-700': toolCall().status === TOOL_STATUS.SUCCESS,
            'bg-amber-100 text-amber-700': toolCall().status === TOOL_STATUS.ERROR,
            'bg-blue-100 text-blue-600': toolCall().status !== TOOL_STATUS.SUCCESS && toolCall().status !== TOOL_STATUS.ERROR
            }">
                @if (toolCall().status === TOOL_STATUS.SUCCESS) {
                <app-icon [type]="'circle-check-big'" [class]="'h-3.5 w-3.5 mr-1 text-emerald-700'" [source]="'lucide'"
                    [size]="'sm'"></app-icon>
                <span>Completed</span>
                } @else if (toolCall().status === TOOL_STATUS.ERROR) {
                <app-icon [type]="'triangle-alert'" [class]="'h-3.5 w-3.5 mr-1 text-amber-700'" [source]="'lucide'"
                    [size]="'sm'"></app-icon>
                <span>Failed</span>
                } @else {
                <span class="inline-flex shrink-0 h-3.5 w-3.5 mr-1 items-center justify-center">
                    <app-icon [type]="'loader-circle'"
                        [class]="'text-blue-600 animate-spin [&>svg]:w-3.5 [&>svg]:h-3.5 [&>svg]:block'"
                        [source]="'lucide'" [size]="'sm'"></app-icon>
                </span>
                <span>In progress</span>
                }
            </div>
        </div>
    </div>

    <div class="p-0 flex-1 min-h-0 overflow-hidden relative">
        @if (toolCall().status !== TOOL_STATUS.SUCCESS && toolCall().status !== TOOL_STATUS.ERROR) {
        <div class="flex flex-col h-full w-full p-6 overflow-auto">
            <div class="space-y-6 shrink-0">
                <p-skeleton width="100%" height="1.5rem" styleClass="rounded-lg"></p-skeleton>
                <p-skeleton width="75%" height="1.5rem" styleClass="rounded-lg"></p-skeleton>
                <p-skeleton width="100%" height="8rem" styleClass="rounded-lg"></p-skeleton>
            </div>
            <div class="flex-1 min-h-0 flex flex-col gap-4 pt-8">
                <p-skeleton width="100%" height="1rem" styleClass="rounded-md"></p-skeleton>
                <p-skeleton width="90%" height="1rem" styleClass="rounded-md"></p-skeleton>
                <p-skeleton width="65%" height="1rem" styleClass="rounded-md"></p-skeleton>
                <div class="flex-1 min-h-[4rem] pt-4">
                    <p-skeleton width="100%" height="100%" styleClass="rounded-lg"></p-skeleton>
                </div>
            </div>
        </div>
        } @else {
        @if (toolViewType() === 'file-operation') {
        <app-file-operation-tool-view [toolCall]="toolCall()"></app-file-operation-tool-view>
        }
        @else if (toolViewType() === 'str-replace') {
        <app-str-replace-tool-view [toolCall]="toolCall()"></app-str-replace-tool-view>
        }
        @else if (toolViewType() === 'web-search') {
        <app-web-search-tool-view [toolCall]="toolCall()"></app-web-search-tool-view>
        }
        @else if (toolViewType() === 'view-image') {
        <div class="h-full w-full flex flex-col min-h-0 overflow-hidden">
            @if (toolCall().response_metadata) {
            <app-multi-format-preview [file]="toolCall().response_metadata"></app-multi-format-preview>
            }
            @else {
            <div class="h-full w-full flex items-center justify-center bg-gray-50">
                <div class="text-gray-500">No image found</div>
            </div>
            }
        </div>
        }
        @else {
        <app-generic-tool-view [toolCall]="toolCall()"></app-generic-tool-view>
        }
        }
    </div>

</div>